// extracted by mini-css-extract-plugin
module.exports = {"textarea":"styles_textarea__gWsPF","error":"styles_error__eYjfw","letterLimit":"styles_letterLimit__7yu_O"};